import React from 'react';
import {
    TimeRange,
    Ngs,
    CancerSites,
    MorphologyTypes,
    Gene,
    Immunotherapy,
    TargetedTherapy,
    Hospitals,
    HospitalCities,
    Pdl1,
    DoctorsList,
    TestDetails,
    GeneName,
    Country,
    State,
    Gender
} from '../../../Components/Icons';

const Icon = ({ name, color = '#41474D', size = 24, strokeWidth = 1.2 }) => {
    const icons = {
        timeRange: <TimeRange size={size} color={color} strokeWidth={strokeWidth} />,
        ngs: <Ngs size={size} color={color} strokeWidth={strokeWidth} />,
        cancerSites: <CancerSites size={size} color={color} strokeWidth={strokeWidth} />,
        morphologyTypes: <MorphologyTypes size={size} color={color} strokeWidth={strokeWidth} />,
        gene: <Gene size={size} color={color} strokeWidth={strokeWidth} />,
        immunotherapy: <Immunotherapy size={size} color={color} strokeWidth={strokeWidth} />,
        targetedTherapy: <TargetedTherapy size={size} color={color} strokeWidth={strokeWidth} />,
        hospitals: <Hospitals size={size} color={color} strokeWidth={strokeWidth} />,
        hospitalCities: <HospitalCities size={size} color={color} strokeWidth={strokeWidth} />,
        pdl1: <Pdl1 size={size} color={color} strokeWidth={strokeWidth} />,
        doctorslist: <DoctorsList size={size} color={color} strokeWidth={strokeWidth} />,
        testDetails: <TestDetails size={size} color={color} strokeWidth={strokeWidth} />,
        geneName: <GeneName size={size} color={color} strokeWidth={strokeWidth} />,
        country: <Country size={size} color={color} strokeWidth={strokeWidth} />,
        state: <State size={size} color={color} strokeWidth={strokeWidth} />,
        gender: <Gender size={size} color={color} strokeWidth={strokeWidth} />,
    };

    return icons[name] || null;
};

export default Icon;